// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckBox_checkbox__R0i10","checkboxBox":"CheckBox_checkboxBox__5Xi4K","checkboxLabel":"CheckBox_checkboxLabel__U80RR","checked":"CheckBox_checked__7BfUX"};